import { Link } from 'react-router-dom';
import { clinic } from '@/mocks/site';

export default function VisitUs() {
  return (
    <section id="visit" className="py-24 md:py-32 bg-white scroll-mt-[96px]">
      <div className="max-w-container mx-auto px-5 md:px-12">
        <div className="rounded-[28px] overflow-hidden bg-white border border-cocoa/20">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative min-h-[380px] lg:min-h-[560px] bg-line">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20editorial%20photograph%20of%20the%20warm%20inviting%20exterior%20and%20front%20entrance%20of%20a%20modern%20neighborhood%20veterinary%20clinic%20with%20soft%20ivory%20facade%20and%20subtle%20sage%20green%20accents%20on%20a%20quiet%20tree%20lined%20street%2C%20abundant%20natural%20daylight%2C%20warm%20inviting%20bright%20atmosphere%2C%20real%20architectural%20setting%2C%20no%20dark%20shadows%2C%20calm%20human%20scale%20storefront%2C%20not%20stock%20photography&width=720&height=840&seq=visit-clinic-bright-2&orientation=portrait&nocache=true"
                alt="Clinic exterior"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8 md:p-14 lg:p-16">
              <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Visit Us</div>
              <h2 className="mt-3 font-display font-bold text-[38px] md:text-[50px] leading-[1.02] text-cocoa">Come by, we'd love to meet your pet.</h2>

              <div className="mt-10 space-y-6 text-[15px]">
                <div className="flex gap-4">
                  <span className="w-6 h-6 flex items-center justify-center text-care mt-0.5"><i className="ri-map-pin-2-line text-[18px]"></i></span>
                  <div>
                    <div className="text-muted text-[13px] font-semibold uppercase tracking-wider">Address</div>
                    <div className="mt-1 text-ink">{clinic.address}</div>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-6 h-6 flex items-center justify-center text-care mt-0.5"><i className="ri-time-line text-[18px]"></i></span>
                  <div>
                    <div className="text-muted text-[13px] font-semibold uppercase tracking-wider">Hours</div>
                    <ul className="mt-1 space-y-1 text-ink">
                      {clinic.hours.map(h => (
                        <li key={h.day} className="flex gap-6"><span className="w-24 text-muted">{h.day}</span><span>{h.time}</span></li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-6 h-6 flex items-center justify-center text-care mt-0.5"><i className="ri-phone-line text-[18px]"></i></span>
                  <div>
                    <div className="text-muted text-[13px] font-semibold uppercase tracking-wider">Phone</div>
                    <div className="mt-1 text-ink">{clinic.phone}</div>
                  </div>
                </div>

                <div className="flex gap-4">
                  <span className="w-6 h-6 flex items-center justify-center text-care mt-0.5"><i className="ri-bus-line text-[18px]"></i></span>
                  <div>
                    <div className="text-muted text-[13px] font-semibold uppercase tracking-wider">Getting Here</div>
                    <div className="mt-1 text-muted">{clinic.parkingNote}</div>
                  </div>
                </div>
              </div>

              <Link to="/book" className="btn-motion mt-10 inline-flex items-center gap-2 h-[54px] px-8 rounded-full bg-cocoa hover:bg-careDark text-white text-[15px] font-semibold cursor-pointer whitespace-nowrap">
                Book an Appointment
                <i className="ri-arrow-right-line text-[16px]"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}